import { Icon } from '../../ui/Icon'

/** Оценка звёздами; читалке — числом. */
export function Stars({ rating, size = 14 }: { rating: number; size?: number }) {
  const whole = Math.round(rating)
  return (
    <span className="rv-stars" role="img" aria-label={`Оценка ${rating} из 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} data-on={n <= whole || undefined}>
          <Icon name={n <= whole ? 'i-star-fill' : 'i-star'} size={size} />
        </span>
      ))}
    </span>
  )
}
